@if (review) {
  <div>
    @if (showTitle) {
      <div>
        <a [routerLink]="['/listing', review.listingId]">
          <strong>
            {{review.listingTitle}}
          </strong>
        </a>
        <br/>
      </div>
    }
    <ng-content>
    </ng-content>
    <br />
    @if (!maxTextLength) {
      <p [innerHtml]="review.text | newlineToBr"></p>
    }
    @if (maxTextLength) {
      <div>
        <p [innerHtml]="review.text | truncate: maxTextLength | newlineToBr"></p>
        @if (review.text.length > maxTextLength) {
          <a href="javascript:;" (click)="showMore.emit(review)">
            Show more...
          </a>
        }
      </div>
    }
  </div>
}